<script>
    import { onMount } from "svelte";
    import moment from 'moment';
    import { ModalBody, ModalFooter, ModalHeader, Modal, Label } from "sveltestrap";
    import backend from "../../../../../server";

    export let isdetail = false;  
    export let playerId; 
    export let campaignId; 
    let isLoading=false; 
    let details={};
    let filter = { id: campaignId, player_id: playerId, status: '', start_date: '', end_date: '' };

    onMount(async () => {
        if (!campaignId || !playerId) {
        console.error("Error: campaignId o playerId no definidos");
        return;
        }
        await getDetailPyaerIdAndCampaignId();
        
     });
   const getDetailPyaerIdAndCampaignId = async()=>{
    const params = {  ...filter,
          start_date: convertDateToISO(filter.start_date),
          end_date: convertDateToISO(filter.end_date) 
        };
    
    try {
        details={}
        isLoading=true
        let response = await backend.freespin.getDetallByPlayerId(params);
    
         if(response.data.status){
            details= response.data.data.campaign
         }
    
    } catch (error) {
      console.log("ERROR:" ,error.messenger)
    }
    isLoading=false
   }
   const closeModal = () => {
        isdetail = false;
    };

    const statusMap = {
    'In Running': { label: 'En curso', class: 'bg-success' },
    'Scheduled': { label: 'Programada', class: 'bg-primary' },
    'Expired': { label: 'Expirada', class: 'bg-warning' },
    'Disabled': { label: 'Deshabilitada', class: 'bg-danger' },
    'Player count fulfilled': { label: 'Cupo completo', class: 'bg-secondary' }
  };

  // Formatear fecha con Moment.js
  const formatDate = (datetime) => {
    if (!datetime) return 'N/A';
    return moment(datetime).format('DD/MM/YYYY HH:mm:ss');
  };

  // Convertir fecha del input a formato ISO para el filtro
  const convertDateToISO = (dateString) => {
    if (!dateString) return '';
    return moment(dateString).toISOString();
  };

</script>

<Modal isOpen={isdetail} size="xl">
    <ModalHeader>
      DETALLES DE FREESPIN: 
    </ModalHeader>
    <ModalBody>
        <div class="freeSpin-modal">
            <div class="row g-2 align-items-center">
              <div class="col-md-4">
                <select  bind:value={filter.status}  class="form-select" >
                  <option value="">Seleccione estatus</option>
                  
                  <option value="1">Activo (In Running)</option>
                  <option value="2">Programada (Scheduled)</option>
                  <option value="3">Expirada (Expired)</option>
                  <option value="4">Deshabilitada (Disabled)</option>
                  <option value="5">Cupo completo (Player count fulfilled)</option>
                </select>
              </div>
              <div class="col-md-4">
                <input   type="date"   bind:value={filter.start_date} class="form-control"  >
              </div>
              <div class="col-md-4">
                <div class="input-group">
                  <input  type="date"   bind:value={filter.end_date} class="form-control"  >

                    <button  on:click={getDetailPyaerIdAndCampaignId} class="btn btn-pink btn-sm ms-2"  title="Buscar" disabled={isLoading} >
                    {#if isLoading}
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cargando...
                    {:else}
                    <i class="fas fa-search"></i>
                    {/if}
                    </button>
                </div>
              </div>
            </div>

              
              {#if details.id}
              <div class="campaign-details mt-4">
                <div class="row mb-3">
                  <div class="col-md-8">
                    <h3>{details.title}</h3>
                    <span class="badge {statusMap[details.status]?.class || 'bg-dark'}">
                      {statusMap[details.status]?.label || 'Estado desconocido'}
                    </span>
                  </div>
                  
                  <div class="col-md-4">
                    <p class="mb-1">ID Campaña: {details.id}</p>
                    <p class="mb-1">Moneda: {details.player_currency}</p>
                  </div>
                </div>
              
                <div class="row g-3">
                  <!-- Primera fila -->
                  <div class="col-md-4">
                    <div class="card h-100">
                      <div class="card-body">
                        <h5 class="card-title">Fechas</h5>
                        <p>Inicio: {formatDate(details.start_date)}</p>
                        <p>Fin: {formatDate(details.end_date)}</p>
                   
                      </div>
                    </div>
                  </div>
              
                  <!-- Segunda fila -->
                  <div class="col-md-4">
                    <div class="card h-100">
                      <div class="card-body">
                        <h5 class="card-title">Detalles Juego</h5>
                        <p>Proveedor: {details.provider_name}</p>
                        <p>Juego: {details.game_name}</p>
                        <p>Apuesta requerida: ${details.product_bet_amount}</p>
                      </div>
                    </div>
                  </div>
              
                  <!-- Tercera fila -->
                  <div class="col-md-4">
                    <div class="card h-100">
                      <div class="card-body">
                        <h5 class="card-title">Rondas Gratis</h5>
                        <p>Rondas restantes: {details.left_freeround}</p>
                        <p>Ganancias totales: ${details.freeround_win_amount}</p>
                        <p>Máx. ganancia: {details.product_max_winning || 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              
                <!-- Detalles adicionales -->
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Configuraciones</h5>
                        <p>Redención múltiple: {details.multiple_redemption ? 'Sí' : 'No'}</p>
                        <p>Requisitos de apuesta: {details.wagering.is_wagering ? 'Sí' : 'No'}</p>
                        <p>Tipo de campaña: {details.type === 'assigned' ? 'Asignada' : 'Aleatoria'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {:else}
              <div class="alert alert-warning mt-4">
                <i class="fas fa-exclamation-triangle me-2"></i>
                No se han encontrado detalles para la campaña y jugador especificados.
              </div>
              
              {/if}
              


          </div>
          
</ModalBody>
<ModalFooter>
  <button class="btn btn-secondary" on:click={closeModal}>
    Cerrar
  </button>
</ModalFooter>
</Modal>

<style>
      .btn-pink {
   background-color: #2a1a28;
    color: white;
  }
  .btn-pink:hover{
      background-color: #FF0090;
    color: white;
  }
  .campaign-details .card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-radius: 8px;
}

.card-title {
  color: #2c3e50;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
}

</style>